var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurricane04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.1921C13.2784 15.6535 11.4912 15.9444 9.5 15.9444C7.50885 15.9444 5.72157 15.6535 4.5 15.1921M3.25 11.2232C4.44286 11.9665 6.79426 12.4722 9.5 12.4722C12.2057 12.4722 14.5571 11.9665 15.75 11.2232M17 6.5C17 7.88071 13.6421 9 9.5 9C5.35786 9 2 7.88071 2 6.5C2 5.11929 5.35786 4 9.5 4C13.6421 4 17 5.11929 17 6.5Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurricane04);
export default __webpack_public_path__ + "static/media/hurricane-04.373c608e1931cb0803cafb9219c06414.svg";
export { ForwardRef as ReactComponent };